if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						var this_ = e.target;

                        var _minval = parseInt($(e.target).attr("min")) || 0;
                        console.log(qty.value," :qty.value: ",_minval)
                        if(_minval > 0){
                          if(qty.value > _minval){
      						this.updateCartQty(item, parseInt(qty.value));
                          }else{
                            $(this_).closest( `product-quantity` ).addClass( `error` );
                            this.updateCartQty(item, parseInt(_minval));
                          }
                        }else{
                          this.updateCartQty(item, parseInt(qty.value));
                        }
					}, 700));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

				const upsell = item.querySelector('._upsell_cta');
				if ( upsell ) {
					upsell.addEventListener('click', (e)=>{
                      var el = e.target;
                      console.log(upsell.dataset,"upsell")
                      var _index = parseInt(upsell.dataset.line) - 1;
                      var pNode = el.closest("._upsell_parent_block");
                      var qtyNode = pNode.querySelector("._discount-list")
                      var qty_value = qtyNode.dataset.min
                      this.updateUpsell(item, parseInt(qty_value));
					})
				}
              //console.log("_upsell_check triggered");
              _upsell_check();
			})
            _saving_update();

		}

      
      updateUpsell(item, newQty){
        let alert = null;
        this.form.classList.add('processing');
        if ( this.querySelector('.alert') ) {
            this.querySelector('.alert').remove();
        }
          
        var propitems = item.querySelector(".propitems")
        var order_properties =  $.trim($(propitems).val());
          var _json_prop = {};
          if(order_properties != ""){
            _json_prop = JSON.parse(order_properties);
            $.each(_json_prop, function(key, value) {
              if(key == "_discount_name"){
                _json_prop[key] = decodeURIComponent(value);
              }
              if(key == "_discount_input"){
                _json_prop[key] = decodeURIComponent(value);
              }
                if(value.indexOf("https%3A%2F%2F") > -1){
                  _json_prop[key] = decodeURIComponent(value);
                }
            });
          }
        //console.log(_json_prop," :_json_prop: ");
			const body = JSON.stringify({
				id: item.dataset.id,
				quantity: newQty,
                properties : _json_prop
			});
        
			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
                      //elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
                        let _cartno = cartItems.querySelector('[data-cart-count]').textContent;
						elm.textContent = _cartno;
                        elm.setAttribute("data-count",_cartno);
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
							
					const event = new Event('cart-updated');
					this.dispatchEvent(event);

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
                    _saving_update();
				});
      }
      
      
		updateCartQty(item, newQty){

			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				id: item.dataset.id,
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
                      //elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
                        let _cartno = cartItems.querySelector('[data-cart-count]').textContent;
						elm.textContent = _cartno;
                        elm.setAttribute("data-count",_cartno);
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
							
					const event = new Event('cart-updated');
					this.dispatchEvent(event);

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
                    _saving_update();
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
              let _cartno = cartItems.querySelector('[data-cart-count]').textContent;
              elm.textContent = _cartno;
              elm.setAttribute("data-count",_cartno);
              //elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}
            _saving_update();
		})
	}

}
function _saving_update() {
  var _totalsaving = $("#moneySaved").val();
  var grt_totalqty = $("#grttotalqty").val() * 1;
  var _savingnum = parseInt($("#moneySaved").attr("data"));
  if(_savingnum <= 0){
    setTimeout(function () {
      $("#_total_saving").parents(".cart__details--row").hide();
      $(".cart__total.cart__details--row").addClass("blank-row");
      $("#_total_saving").html(_totalsaving);
    },500)
  }else{
    setTimeout(function () {
      $("#_total_saving").parents(".cart__details--row").show();
      $(".cart__total.cart__details--row").removeClass("blank-row");
      $("#_total_saving").html(_totalsaving);
    },500)
  }
  
  if($("#site-cart-sidebar .cart-item.cart-item--gift-wrapping").length){
    $("#site-cart-sidebar #cart-gift-wrapping").prop("checked",true);
  }else{
    $("#site-cart-sidebar #cart-gift-wrapping").prop("checked",false);
  }
	/* 
	if(grt_totalqty > 24){
		$(".patchcount-msg-alternate").removeClass("hide");
		$(".patchcount-msg").addClass("hide");
	}else{
		$(".patchcount-msg-alternate").addClass("hide");
		$(".patchcount-msg").removeClass("hide"); 
	}
	*/
	var $elig = $(".eligibilityFreeApproval");
	if (grt_totalqty > 9) {
		$(".patchcount-msg-alternate").removeClass("hide");
		$(".patchcount-msg").addClass("hide");
	} else {
		$(".patchcount-msg-alternate").addClass("hide");
		$(".patchcount-msg").removeClass("hide");

		var lower_approval_status = $(".eligibilityFreeApproval").attr("data-lower_approval_status")
		var arr = [];
		var paidvid = $(".eligibilityFreeApproval").attr("data-paidvid") * 1;
		//console.log(lower_approval_status," :lower_approval_status", paidvid, " :paidvid =========================================");
		if($elig.length && lower_approval_status == "true"){
			arr.push(paidvid);
			removeProcuct(arr);
		}
	}
	console.log($elig," :$elig")
	setTimeout(function(){
		if(typeof rmproductcart == 'function'){
			rmproductcart();
		}
	})

  if($(".grtninjapatches").length){
	$(".grt-free-ship-wrapper").removeClass("grt-ninja-patches");
  }

}


$(function () {
	_saving_update();
  var cartWrappingForm = document.getElementById('cart-wrapping');
  $(document).on("change","#cart-gift-wrapping",function(){
    var _ischecked = $(this).is(":checked");
    if ( document.getElementById('site-cart-sidebar') ) {
      document.getElementById('site-cart-sidebar').scrollTo({top: 0, behavior: 'smooth'});
    }
    var _parentNode = $( this ).closest( `#cart-wrapping` );
    var _currNode = $(this);
    //console.log(_currNode," :_currNode")
    const vid = _parentNode.find( `[vid]` ).attr( `vid` );
    if (_ischecked) {
        if ( typeof vid !== 'undefined' && vid ) {
            _parentNode.find( `#add-to-cart- [name="id"]` ).val( vid );
        }
        setTimeout(() => {
            _parentNode.find("[data-js-product-add-to-cart]").trigger("click");
        }, 100);
    } else {
      if(document.querySelector('.cart-item--gift-wrapping') ) {
        $('.cart-item--gift-wrapping .remove').get(0).click();
        $(".cart-item--gift-wrapping .product__quantity").val(0).trigger("blur");
        _currNode.prop('checked', false);
      }
    }
  })
})